// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3093":"css/admin-app.6902","6294":"css/app.6902"}[chunkId] + ".css";
};